import { HStack, Text, Tag, TagLeftIcon, VStack, Badge } from '@chakra-ui/react'
import { FiMail } from 'react-icons/fi';
import { IApiTradeResponse } from '../../models/api/trade/IApiTradeResponse';
import './AutocompleteHit.css';

export interface IAutocompleteTradeHitProps {
    item: IApiTradeResponse;
    components: any;
    onClick?(): void;
}

export const AutocompleteTradeHit = ({ item, components, onClick }: IAutocompleteTradeHitProps) => (
    <div onClick={onClick}>
        <div className="aa-ItemContent">
            <div className="aa-ItemContentBody">
                <div className="aa-ItemContentDescription">
                    <strong><components.Highlight hit={item} attribute="value" /></strong>
                </div>
            </div>
        </div>
    </div>
);